<style scoped>
tr:nth-child(odd) {
  background: #f6f6f6;
}
.address-add-right-pos {
  float: right;
}
</style>

<template>
  <v-layout column wrap>
    <v-layout align-center row>
      <v-flex xs4 md5 lg8 pa-4>
        <v-text-field
          v-model="search"
          prepend-icon="search"
          label="Search"
          hide-details
        ></v-text-field>
      </v-flex>
      <v-flex xs3 md4 lg4 pa-3>
        <address-add
          v-if="allowAddAdress"
          :collection="collection"
          @onSuccess="onSuccessAddAddress"
          class="address-add-right-pos"
        ></address-add>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12>
        <v-data-table
          :headers="headers"
          :items="mappedItems"
          :search="search"
          :must-sort="true"
          class="elevation-1"
          hide-actions
        >
          <template v-slot:items="{ item: address }">
            <tr
              :class="{
                'green--text': selectedId === address.id
              }"
            >
              <td>{{ address.number }}</td>
              <td>
                <address-name-format
                  :names="[address.name1, address.name2, address.name3]"
                ></address-name-format>
              </td>
              <td>{{ address.street }} {{ address.houseNumber }}</td>
              <td>{{ address.city }}</td>
              <td>{{ address.postalCode }}</td>
              <td>{{ address.country }}</td>
              <td v-if="editable">
                <address-edit
                  :collection="collection"
                  :address="address"
                  :selected="selectedId === address.id"
                ></address-edit>
              </td>
              <td v-if="deletable">
                <v-icon v-if="!address.number" @click="onDelete(address.id)">
                  delete
                </v-icon>
              </td>
              <td v-if="selectable">
                <v-btn
                  class="ma-0"
                  :class="{
                    'elevation-5 green green--text': selectedId === address.id
                  }"
                  color="blue"
                  outline
                  small
                  @click="$emit('select', address)"
                >
                  <v-icon small class="pr-1" v-if="selectedId === address.id">
                    check
                  </v-icon>
                  <v-icon small class="pr-1" v-else>playlist_play</v-icon>
                  <span v-if="selectedId == address.id">Selected address</span>
                  <span v-else>Select address</span>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import AddressNameFormat from "@/components/AddressNameFormat.vue";
import AddressEdit from "@/components/AddressEdit.vue";
import AddressAdd from "@/components/AddressAdd.vue";

const headers = [
  {
    text: "No.",
    value: "number"
  },
  {
    text: "Name",
    value: "name"
  },
  {
    text: "Street",
    value: "street"
  },
  {
    text: "City",
    value: "city"
  },
  {
    text: "Postal Code",
    value: "postalCode"
  },
  {
    text: "Country",
    value: "country"
  }
];

function emptyHeaders(count) {
  const emptyHeaders = new Array(count);
  return emptyHeaders.fill({
    text: "",
    sortable: false
  });
}

export default {
  components: {
    AddressNameFormat,
    AddressEdit,
    AddressAdd
  },
  props: {
    collection: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    deletable: Boolean,
    editable: Boolean,
    selectable: Boolean,
    selectedId: String,
    allowAddAdress: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      search: ""
    };
  },
  computed: {
    headers() {
      const count =
        (this.deletable ? 1 : 0) +
        (this.editable ? 1 : 0) +
        (this.selectable ? 1 : 0);
      return headers.concat(emptyHeaders(count));
    },
    mappedItems() {
      return this.items.map(item => {
        return {
          ...item,
          name: `${item.name1} ${item.name2} ${item.name3}`
        };
      });
    }
  },
  methods: {
    onDelete(id) {
      this.$store.dispatch("customer/deleteAddress", {
        id,
        collection: this.collection
      });
    },
    onSuccessAddAddress(address) {
      this.$emit("onSuccessAddAddress", address);
    }
  }
};
</script>
